/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function filterAddedOptions(item: MoveableItem): boolean {
  return item.addedOption === true
}
